import React from 'react';
import { Chip, useTheme } from '@/ui';

interface RouteItem { key: string; label: string }

interface OuterNavChipsProps {
  routes: Array<RouteItem>;
  selectedKey: string;
  onSelect: (key: string) => void;
}

const OuterNavChips: React.FC<OuterNavChipsProps> = ({ routes, selectedKey, onSelect }) => {
  const theme = useTheme();
  return (
    <>
      {routes.map((route) => (
        <Chip
          key={route.key}
          label={route.label}
          onClick={() => onSelect(route.key)}
          sx={{
            backgroundColor: selectedKey === route.key ? '#155f54' : 'white',
            color: selectedKey === route.key ? 'white' : 'text.primary',
            border: `0.5px solid ${selectedKey === route.key ? '#155f54' : '#1a5053'}`,
            borderRadius: '999px',
            fontSize: '16px',
            fontWeight: 400,
            px: 1,
            py: 0.75,
            // Smooth transition for selection state
            transition: 'background-color 0.15s ease, color 0.15s ease, transform 0.1s ease',
            // Prevent layout shift during selection
            flexShrink: 0,
            '&:hover': {
              backgroundColor: selectedKey === route.key ? '#0f4a45' : theme.palette.grey[100],
            },
            // Touch feedback for mobile
            '&:active': {
              transform: 'scale(0.96)',
            },
          }}
        />
      ))}
    </>
  );
};

export default OuterNavChips;


